export default __webpack_public_path__ + "static/insect-based-dog-food-3-d8b49f424efa73b26906d1c30440afd7.jpg";